import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editoria',
  templateUrl: './editoria.component.html',
  styleUrls: ['./editoria.component.css']
})
export class EditoriaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
